window.loadScript = function( url, id, callback ) {
    if(!window.loadedAsyncScripts) window.loadedAsyncScripts = [];

    if(window.loadedAsyncScripts.indexOf(id) > -1){
        callback();
    }else{
        var script = document.createElement( "script" )
        script.type = "text/javascript";
        if(script.readyState) {  //IE
            script.onreadystatechange = function() {
                if ( script.readyState === "loaded" || script.readyState === "complete" ) {
                    script.onreadystatechange = null;
                    window.loadedAsyncScripts.push(id);
                    callback();
                }
            };
        } else {  //Others
            script.onload = function() {
                window.loadedAsyncScripts.push(id);
                callback();
            };
        }
        script.src = url;
        document.getElementsByTagName( "head" )[0].appendChild( script );
    }
}
